import React from "react"
import "./App.css"
import FfmpegPage from "./pages/FfmpegPage/FfmpegPage"

function App() {
  return (
    <div className="App">
      <FfmpegPage></FfmpegPage>
    </div>
  )
}

export default App
